// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"0c8ea929","787":"21643302"}[chunkId] + ".chunk.js";
};